export default __webpack_public_path__ + "static/media/logo.1cfc49d7.svg";